import { render, staticRenderFns } from "./email_update.vue?vue&type=template&id=3c99230b&scoped=true&"
import script from "./email_update.vue?vue&type=script&lang=js&"
export * from "./email_update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c99230b",
  null
  
)

export default component.exports